/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Notfound_Heading_Off_MapInputs */



/**
* | output |
* | --- |
* | "You've wandered off the map" |
*
* @param {Error_Notfound_Heading_Off_MapInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_notfound_heading_off_map = /** @type {((inputs?: Error_Notfound_Heading_Off_MapInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Notfound_Heading_Off_MapInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Du bist von der Karte abgekommen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous êtes sorti de la carte")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("你走出了地图边界")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("你走出地圖之外了")
	if (locale === "ko") return /** @type {LocalizedString} */ ("지도 밖으로 벗어났습니다")
	return /** @type {LocalizedString} */ ("You've wandered off the map")
});